import React from 'react';
import 'twin.macro';
import ButtonGroup from 'components/Form/ButtonGroup';
import Button from 'components/Buttons/Button';
import { MinusIcon, PlusIcon } from '@heroicons/react/16/solid';
import { Menu } from 'components/Menu';
import { css } from 'twin.macro';

interface Props {
  onChange: (value: number) => void;
  value: number;
  min?: number;
  max?: number;
}

export function FontSizeSelector(props: Props) {
  const { onChange, value, min = 1, max } = props;
  return (
    <ButtonGroup tw="items-stretch">
      <Button
        icon={MinusIcon}
        tw="px-2"
        disabled={value <= min}
        onClick={() => onChange(value - 1)}
      />
      <Menu
        css={[
          // Un peu crado mais sinon le bouton ne se stretch pas en hauteur
          // et j'avais trop peur de trop toucher au Menu
          css`
            div,
            button {
              height: 100%;
            }
          `,
        ]}
        portal
      >
        <Menu.Button tw="px-1.5 min-w-[3rem]">{value}</Menu.Button>
        <Menu.Items>
          {[6, 8, 10, 12, 14, 16, 18, 21, 24, 28]
            .filter(nb => nb >= min && (max ? nb <= max : true))
            .map(v => (
              <Menu.Item
                key={v}
                onClick={() => onChange(v)}
                text={v.toString()}
              />
            ))}
        </Menu.Items>
      </Menu>
      <Button
        icon={PlusIcon}
        tw="px-2"
        disabled={max ? value >= max : false}
        onClick={() => onChange(value + 1)}
      />
    </ButtonGroup>
  );
}
